export default __webpack_public_path__ + "static/media/microscope.055abcfd.svg";